import Vue from 'vue';

//流程轨迹列表
import SHWFTrack from './track/list/index.js'
Vue.use(SHWFTrack);

//轨迹抽屉
import SHWFTrackDrawer from './track/drawer/index.js'
Vue.use(SHWFTrackDrawer);


// WEBPACK FOOTER //
// ./src/components/base/view/wf/exec/cmps/cmps.js